import { createReducer, on, Action } from '@ngrx/store';
import * as AuthActions from './auth.actions';
import { User } from '@app/core/interfaces';

export const authFeatureKey = 'auth';

export interface State {
  isAuthenticated: boolean;
  loading: boolean;
  user: User | null;
}

export const initialState: State = {
  isAuthenticated: false,
  // A protected route can be evaluated before Amplify has restored its persisted
  // session. Keep that route pending until the restore effect has answered.
  loading: true,
  user: null
};

const authReducer = createReducer(
  initialState,
  on(AuthActions.AuthInitialized, (state, { state: authState }) => ({
    ...state,
    ...authState,
    loading: false
  })),
  on(AuthActions.UpdateUserAuthDetails, (state, payload) => ({
    ...state,
    isAuthenticated: payload.isAuthenticated,
    user: payload.user,
    // Also settles the pending SessionRestoreRequested, which is what this action answers
    // on startup; leaving `loading` set would hang any spinner bound to it.
    loading: false,
  })),
  on(AuthActions.SessionRestoreRequested, (state) => ({
    ...state,
    loading: true
  })),
  on(AuthActions.LogoutRequested, (state, action) => ({
    ...state,
    loading: true
  })),
  on(AuthActions.LogoutSuccess, (state, action) => ({
    ...state,
    isAuthenticated: false,
    user: null,
    loading: false
  })),
  on(AuthActions.LogoutFailure, (state, action) => ({
    ...state,
    loading: false
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return authReducer(state, action);
}
